import { GridRenderCellParams } from '@mui/x-data-grid';
import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types/';

import { usePermission } from '../../../../hooks';
import { useGenGridCol } from '../../../../utils/ComponentHelper';
import { TableColumnKey } from '../types/TableColumnKeys';

interface IProps {
  renderOperationsCell: (params: GridRenderCellParams) => React.ReactNode;
}

const useTableColumns = (props: IProps) => {
  const { renderOperationsCell } = props;

  const { hasPermission } = usePermission();

  const shouldHideOperationColumn = !hasPermission(
    AgentPortalFeatureCode.Setting.ExchangeRateConfiguration.EditRecord
  );

  const columns = [
    useGenGridCol(TableColumnKey.operation, {
      renderCell: renderOperationsCell,
      hide: shouldHideOperationColumn,
    }),
    useGenGridCol(TableColumnKey.programName, { minWidth: 170 }),
    useGenGridCol(TableColumnKey.from, {}),
    useGenGridCol(TableColumnKey.to, {}),
    useGenGridCol(TableColumnKey.currentExchangeRate, { minWidth: 190 }),
    useGenGridCol(TableColumnKey.adjustmentType, {}),
    useGenGridCol(TableColumnKey.adjustmentAmount, { minWidth: 170 }),
    useGenGridCol(TableColumnKey.exchangeRateAfterAdjustment, { minWidth: 190 }),
  ];

  return columns;
};

export default useTableColumns;
